// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var MaterialUI  = require("bs-material-ui/lib/js/src/MaterialUI.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./Button.css')));

function valueFromEvent(evt) {
  return evt.target.value;
}

var component = ReasonReact.statelessComponent("Button");

function make(onClick, children) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return ReasonReact.element(/* None */0, /* None */0, MaterialUI.Button[/* make */1](/* None */0, /* Some */["Button-root"], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[onClick], /* array */[children]));
    });
  return newrecord;
}

exports.valueFromEvent = valueFromEvent;
exports.component      = component;
exports.make           = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/Button.re
// module id = 187
// module chunks = 0